import React, { useState } from "react";

type IconProps = {
	sport: string;
	category: string;
	tournament: string;
};

export default function ResultsTournamentIcon(props: IconProps) {
	const [src] = useState(makeIconSrc(props));
	const [isLoading, setIsLoading] = useState(true);

	return (
		<picture className="nav--tertiary__icon u-icon u-icon--base u-mar--right--micro">
			<img
				// @ts-expect-error
				loading="lazy"
				className="nav--tertiary__icon__inner u-icon--base"
				style={isLoading ? { opacity: "0" } : {}}
				src={src}
				onError={({ currentTarget }) => {
					currentTarget.onerror = null;
				}}
				onLoad={() => setIsLoading(false)}
			/>
		</picture>
	);
}

function makeIconSrc({ sport, category, tournament }: IconProps) {
	return `${WEBPACK_CDN_ROOT_URL}/icons/sport/${sport}/${category}/${tournament}/${tournament}.svg`;
}
